import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import Card from "components/Card/Card";
import NotificationIcon from "assets/img/NotificationIcon";
import { Blink } from "@bdchauvette/react-blink";
import NotificationLow from "assets/img/NotificationLow";
import { redColor, yellowColor } from "assets/jss/material-dashboard-react.js";
import { useHistory } from "react-router-dom";
import api from "../../api";

function NavAlarm() {
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState("");
  const alerts = useSelector((state) => state.alarm.alarmData);
  const [blink, setBlink] = useState(false);
  const [humidity, setHumidity] = useState("");
  const [temperature, setTemperature] = useState("");
  const buildingName = useSelector(
    (state) => state.isLogged.data.building.name
  );

  const history = useHistory();
  const locale = "en";

  // Redirect to alerts page
  const redirectToAlert = () => {
    history.push("/admin/eventsviewer");
  };

  // Function to update live time (HH:MM)
  const updateTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    setTime(`${hours}:${minutes}`);
    setDate(now);
  };

  // Update time every minute
  useEffect(() => {
    updateTime(); // initialize immediately
    const timer = setInterval(updateTime, 1000); // updates every second
    return () => clearInterval(timer); // cleanup
  }, []);

  // Update temperature and humidity
  useEffect(() => {
    const fetchData = () => {
      api.floor
        .cpmGetDevData()
        .then((res) => {
          if (res["NONGL_SS_CPM"]) {
            const eqp = Object.values(res["NONGL_SS_CPM"])[0]["Eqp_Attributes"];
            setTemperature(eqp["AMBIENT_TEMP"].presentValue);
            setHumidity(eqp["HUMIDITY_MONITORING"].presentValue);
          }
        })
        .catch((error) => { });
    };

    fetchData();
    const timer = setInterval(fetchData, 5000); // refresh every 5s
    return () => clearInterval(timer);
  }, []);

  // Blink logic for alerts
  useEffect(() => {
    if (alerts?.system?.length > 0) {
      const ackActive = alerts.system.filter((each) => each.acknowledged === 0);
      setBlink(ackActive.length > 0);
    }
  }, [alerts.system]);

  // Format date string
  const day = date.toLocaleDateString(locale, { weekday: "short" });
  const formattedDate = `${day}, ${date.getDate()} ${date.toLocaleDateString(
    locale,
    {
      month: "short",
    }
  )}`;

  const formatDateTime = () => {
    const now = new Date();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    const day = now.toLocaleDateString("en-IN", {
      weekday: "short",
    });

    const date = now.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
    });

    return `${time} ${day}, ${date}`;
  };

  const [dateTime, setDateTime] = useState(formatDateTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(formatDateTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);


  return (
    <Grid
      container
      xs={12}
      direction="row"
      justify="flex-end"
      alignItems="center"
    >
      {localStorage.getItem("roleID") !== "6" ? (
        <>
          {/* System Alerts */}
          <Grid xs={2}>
            {blink ? (
              <Blink>
                <ButtonBase style={{ width: "100%" }} onClick={redirectToAlert}>
                  <Card
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                      backgroundColor: redColor[0],
                    }}
                  >
                    <Grid container xs={12} style={{ height: 35 }}>
                      <Grid xs={6}>
                        <NotificationIcon fillColor={redColor[0]} />
                      </Grid>
                      <Grid xs={6}>
                        <div
                          style={{
                            color: "#ffffff",
                            marginTop: 10,
                            fontSize: 16,
                          }}
                        >
                          {alerts.system.length}
                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                </ButtonBase>
              </Blink>
            ) : (
              <ButtonBase style={{ width: "100%" }} onClick={redirectToAlert}>
                <Card
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    backgroundColor: redColor[0],
                  }}
                >
                  <Grid container xs={12} style={{ height: 35 }}>
                    <Grid item xs={6}>
                      <NotificationIcon fillColor={redColor[0]} />
                    </Grid>
                    <Grid xs={6}>
                      <div
                        style={{
                          color: "#ffffff",
                          marginTop: 10,
                          fontSize: 16,
                        }}
                      >
                        {alerts.system.length}
                      </div>
                    </Grid>
                  </Grid>
                </Card>
              </ButtonBase>
            )}
          </Grid>

          {/* Solution Alerts */}
          <Grid xs={2} style={{ marginLeft: 4 }}>
            <ButtonBase style={{ width: "100%" }} onClick={redirectToAlert}>
              <Card
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  backgroundColor: yellowColor[0],
                }}
              >
                <Grid container xs={12} style={{ height: 35 }}>
                  <Grid xs={6}>
                    <NotificationLow />
                  </Grid>
                  <Grid xs={6}>
                    <div
                      style={{ color: "#ffffff", marginTop: 10, fontSize: 16 }}
                    >
                      {alerts.solution.length}
                    </div>
                  </Grid>
                </Grid>
              </Card>
            </ButtonBase>
          </Grid>

          {/* Live Time */}
          <Grid xs={3} style={{ marginLeft: 4 }}>
            <Card
              style={{
                marginTop: 0,
                marginBottom: 0,
                backgroundColor: "#f2f2f7",
              }}
            >
              <Grid container xs={12} style={{ height: 35 }}>
                <Grid xs={12}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      fontSize: "2vh",
                      marginTop: "0.5vh",
                    }}
                  >
                    {time} {formattedDate}
                  </div>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </>
      ) : (
        <Grid xs={3} style={{ marginLeft: "48vh", marginTop: "-2vh" }}>
          <Card
            style={{
              marginTop: 0,
              marginBottom: 0,
              backgroundColor: "#f2f2f7",
            }}
          >
            <Grid container xs={12} style={{ height: 35 }}>
              <Grid xs={12}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                    fontSize: "2vh",
                    marginTop: "0.5vh",
                  }}
                >
                  {/* {time} {formattedDate} */}
                  {dateTime}
                </div>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      )}
    </Grid>
  );
}

export default NavAlarm;
